import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Apps from './components/Apps';
import Tasks from './components/Tasks';
import Pipeline from './components/Pipeline';
import Prospects from './components/Prospects';
import Revenue from './components/Revenue';
import Social from './components/Social';
import Funnels from './components/Funnels';
import BookingDashboard from './components/BookingDashboard';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route index element={<Dashboard />} />
                <Route path="apps" element={<Apps />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="pipeline" element={<Pipeline />} />
                <Route path="prospects" element={<Prospects />} />
                <Route path="revenue" element={<Revenue />} />
                <Route path="social" element={<Social />} />
                <Route path="funnels" element={<Funnels />} />
                <Route path="bookings" element={<BookingDashboard />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
